<template>
  <mi-btn
    :class="problemType=== 'AMBIGUOUS'? 'q-mb-md': 'q-ml-md'"
    outline
    :loading="isLoadingSendToSearchBtn"
    class="bom-validation-send-to-search-btn"
    @click="onHandleSendToSearchBtn"
  >
    Send to search
  </mi-btn>
  <send-to-search-modal
    :model-value="isSendToSearchModalOpen"
    :toggle-open-modal="toggleSendToSearchModal"
    :tar-filter-kvs-list="tarFilterKvsList"
    :problem-type="problemType"
    :bom-validation-results="bomValidationResultsModified"
  >
  </send-to-search-modal>
  <product-model-unavailable-modal
    :model-value="isChangePMModalOpen"
    :product-models="completePMListWithUserExports"
    :handle-change-pm-modal-open="onHandleOpenChangePmModal"
    :unavailable-product-model="{ businessName: bomValidationResults?.userExportsName,
                                  productModelId: bomValidationResults?.productModelId }"
    :open-send-to-search-modal="onHandleOpenSendToSearchModal"
  >
  </product-model-unavailable-modal>
</template>

<script>
  import { MiBtn } from '@/packages/@mi-library'
  import { ref } from 'vue'
  import { getProductModels } from '@/api'
  import { useStore } from 'vuex'
  import { PM_TYPE } from '@/constants'
  import cloneDeep from 'lodash.clonedeep'
  import SendToSearchModal from './BomValidationResultsElementsSendToSearchModal.vue'
  import ProductModelUnavailableModal from './BomValidationResultsElementsPMUnavailableModal.vue'

  export default {
    name: 'BomValidationResultsElementsSendToSearchBtn',
    components: {
      ProductModelUnavailableModal,
      SendToSearchModal,
      MiBtn
    },
    props: {
      tarFilterKvsList: {
        type: Array,
        required: false,
        default: () => []
      },
      problemType: {
        type: String,
        required: true
      },
      bomValidationResults: {
        type: Object,
        required: false,
        default: () => {}
      }
    },
    setup(props) {
      const isSendToSearchModalOpen = ref(false)
      const store = useStore()
      const isChangePMModalOpen = ref(false)
      const isLoadingSendToSearchBtn = ref(false)

      const completePMListWithUserExports = ref([])
      const bomValidationResultsModified = ref(cloneDeep(props.bomValidationResults))

      const onHandleOpenChangePmModal = () => {
        isChangePMModalOpen.value = !isChangePMModalOpen.value
      }

      const isValidationPmAvailable = async () => {
        const productModelsList = await getProductModels()
        const exportsLists = await store.dispatch('rule-validation/fetchUserExportsByTypes')

        const basic = Array.isArray(exportsLists.basic) ? exportsLists.basic : []
        const bom = Array.isArray(exportsLists.bom) ? exportsLists.bom : []
        const pms = Array.isArray(productModelsList) ? productModelsList : []

        completePMListWithUserExports.value = [
          ...basic.map(item => ({
            ...item,
            businessName: item.onDemandExportMetadata.exportName
          })),
          ...bom.map(item => ({
            ...item,
            businessName: item.onDemandExportMetadata.exportName
          })),
          ...pms
        ]

        return completePMListWithUserExports.value
          .some(item => item.id === props.bomValidationResults?.productModelId)
      }

      const toggleSendToSearchModal = (toOpen = true) => {
        if (!toOpen) {
          bomValidationResultsModified.value = cloneDeep(props.bomValidationResults)
        }
        isSendToSearchModalOpen.value = toOpen
      }

      const onHandleOpenSendToSearchModal = (selectedProductModel = null) => {
        if (selectedProductModel) {
          bomValidationResultsModified.value.productModelId = selectedProductModel.id
          bomValidationResultsModified.value.businessName = selectedProductModel.businessName
          bomValidationResultsModified.value.userExportsName = selectedProductModel.onDemandExportMetadata?.exportName
          bomValidationResultsModified.value.encodedBusinessName = selectedProductModel.encodedBusinessName
          bomValidationResultsModified.value.productModelType = selectedProductModel?.productModelType
          bomValidationResultsModified.value.modified = true
        }

        toggleSendToSearchModal()
      }

      const onHandleSendToSearchBtn = async () => {
        isLoadingSendToSearchBtn.value = true

        if (props.bomValidationResults?.productModelType === PM_TYPE.USER_EXPORTS) {
          const pmAvailable = await isValidationPmAvailable()
          if (!pmAvailable) {
            onHandleOpenChangePmModal()
          }
          else {
            onHandleOpenSendToSearchModal()
          }
        }
        else {
          onHandleOpenSendToSearchModal()
        }

        isLoadingSendToSearchBtn.value = false
      }

      return {
        isSendToSearchModalOpen,
        onHandleSendToSearchBtn,
        onHandleOpenSendToSearchModal,
        isChangePMModalOpen,
        onHandleOpenChangePmModal,
        completePMListWithUserExports,
        bomValidationResultsModified,
        isLoadingSendToSearchBtn,
        toggleSendToSearchModal
      }
    }
  }
</script>

<style lang="scss" scoped>
  .bom-validation-send-to-search-btn {
    width: 110px;
    font-size: 14px;
    padding: 8px;
    height: 32px;
  }
</style>
